import React from 'react'
import classNames from 'classnames'
import { IModalTitleProps } from './interface'

import './styles.scss'

const baseClass = 'modal-title'


const ModalTitle: React.FC<IModalTitleProps> = ({ children, className, ...rest }) => (
  <div className={classNames(baseClass, { [className]: className })} {...rest}>
    {children}
  </div>
)

export default ModalTitle
